<div class="modal-container">
  <!-- Modal Header: Simple, clean, no glowing boxes -->
  <div class="modal-header">
    <div class="header-title">
      <i-tabler name="tools-kitchen-2" class="title-icon"></i-tabler>
      <div class="title-text-group">
        <h2>Detalles de Picnic</h2>
        <div class="subtitle-wrap">
          <span class="file-subtitle" *ngIf="fileNumber">
            File <strong>{{ fileNumber }}</strong>
          </span>
          <span class="file-padre-badge" *ngIf="isSSFFPadre">
            Salida Fija (Padre)
          </span>
        </div>
      </div>
    </div>
    <button
      mat-icon-button
      (click)="handleCloseModal()"
      class="close-btn"
      matTooltip="Cerrar modal"
    >
      <i-tabler name="x"></i-tabler>
    </button>
  </div>

  <mat-dialog-content class="modal-body">
    <!-- File Context Strip: Clean metadata ribbon (CLIENTE | ITINERARIO | ACTIVIDAD) -->
    <div class="file-summary-bar">
      <div class="summary-item">
        <span class="item-label">Cliente</span>
        <span class="item-value">{{ clientName }}</span>
      </div>
      <div class="summary-divider"></div>
      <div class="summary-item">
        <span class="item-label">Itinerario</span>
        <span class="item-value">{{ itineraryName }}</span>
      </div>
      <div class="summary-divider"></div>
      <div class="summary-item">
        <span class="item-label">Actividad</span>
        <span class="item-value highlight">{{ activityName }}</span>
      </div>
    </div>

    <!-- Section 1: Headcount Metric Ribbon with Indicative Role Colors matching Cuadro Picnic -->
    <div class="detail-section">
      <div class="section-header-row">
        <h3 class="section-title">
          <span>Proporciones</span>
        </h3>
      </div>

      <div class="headcount-summary-strip">
        <div class="metric-cell metric-total">
          <span class="metric-label">Total en Mesa</span>
          <span class="metric-value">{{ totalMesaCount }}</span>
        </div>
        <div class="metric-divider"></div>
        <div class="metric-cell metric-pax">
          <span class="metric-label">PAX</span>
          <span class="metric-value">{{ activePaxCount }}</span>
        </div>
        <div class="metric-divider"></div>
        <div class="metric-cell metric-tc">
          <span class="metric-label">TC</span>
          <span class="metric-value">{{ activeTcCount }}</span>
        </div>
        <ng-container *ngIf="infantCount > 0">
          <div class="metric-divider"></div>
          <div class="metric-cell metric-infant">
            <span class="metric-label">Infantes (&lt; 3 años)</span>
            <span class="metric-value">{{ infantCount }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="childCount > 0">
          <div class="metric-divider"></div>
          <div class="metric-cell metric-child">
            <span class="metric-label">Niños (3–12 años)</span>
            <span class="metric-value">{{ childCount }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="staffCount > 0">
          <div class="metric-divider"></div>
          <div class="metric-cell metric-staff">
            <span class="metric-label">Staff</span>
            <span class="metric-value">{{ staffCount }}</span>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Section 2: Servicios de Alimentación (Highlighted rows by Destinatario role) -->
    <div class="detail-section">
      <div class="section-header-row">
        <h3 class="section-title">
          <span>Servicios de Alimentación</span>
          <span class="section-count-hint" *ngIf="!isLoadingDetails">
            ({{ groupedAybServices.length }})
          </span>
        </h3>
      </div>

      <!-- Loading State inside services section -->
      <div class="loading-state-container" *ngIf="isLoadingDetails">
        <mat-spinner diameter="24"></mat-spinner>
        <span>Cargando servicios de alimentación...</span>
      </div>

      <div class="service-table-container" *ngIf="!isLoadingDetails">
        <table class="styled-table">
          <thead>
            <tr>
              <th style="width: 24%">Destinatario</th>
              <th style="width: 38%">Servicio</th>
              <th style="width: 26%">Proveedor</th>
              <th style="width: 12%; text-align: right">Cant.</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let serviceItem of groupedAybServices"
              class="service-data-row"
              [ngClass]="
                resolveRecipientRowClass(serviceItem.destinatarioServicio)
              "
            >
              <td class="destinatario-cell">
                <span
                  class="destinatario-badge"
                  [ngClass]="
                    resolveRecipientBadgeClass(serviceItem.destinatarioServicio)
                  "
                >
                  <span class="dest-dot"></span>
                  <span class="dest-label">{{
                    serviceItem.destinatarioServicio || "Sin Destinatario"
                  }}</span>
                </span>
              </td>
              <td class="service-name-cell">
                <span class="service-name-text">{{
                  serviceItem.nombreServicio || "-"
                }}</span>
              </td>
              <td class="provider-cell">
                <span
                  class="prov-name"
                  [class.empty-prov]="!serviceItem.nombreProveedor"
                >
                  {{ serviceItem.nombreProveedor || "Sin proveedor asignado" }}
                </span>
              </td>
              <td class="count-cell" style="text-align: right">
                <span class="quantity-number">{{
                  getServiceQuantity(serviceItem)
                }}</span>
              </td>
            </tr>
            <tr *ngIf="groupedAybServices.length === 0">
              <td colspan="4" class="empty-state">
                <div class="empty-state-content">
                  <i-tabler name="file-off"></i-tabler>
                  <span
                    >No se registraron servicios de alimentación adicionales
                    para esta actividad.</span
                  >
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Section 3: Restricciones Alimentarias(Functional, indicative dietary colors) -->
    <div class="detail-section">
      <div class="section-header-row">
        <h3 class="section-title">
          <span>Restricciones Alimentarias</span>
          <span class="critical-alert-label" *ngIf="hasCriticalRestrictions">
            · Alergias críticas detectadas
          </span>
        </h3>
      </div>

      <div
        class="restrictions-container"
        *ngIf="getParsedPassengerRestrictions().length > 0; else noRestrictions"
      >
        <div
          class="passenger-restriction-row"
          *ngFor="let paxDetail of getParsedPassengerRestrictions()"
          [class.has-critical-alert]="paxDetail.hasAllergiesOrCritical"
        >
          <div class="pax-meta-col">
            <span class="pax-name">{{ paxDetail.passengerName }}</span>
            <span class="pax-type-text">({{ paxDetail.passengerType }})</span>
            <span
              class="critical-flag"
              *ngIf="paxDetail.hasAllergiesOrCritical"
            >
              <i-tabler name="alert-triangle"></i-tabler>
              <span>Alergia / Celíaco</span>
            </span>
          </div>

          <div class="pax-tags-col">
            <ng-container *ngFor="let tag of paxDetail.restrictions">
              <!-- Critical medical tag (allergy / celiac): clear red alert -->
              <span
                class="tag-item tag-dietary-critical"
                *ngIf="isCriticalRestrictionTag(tag)"
              >
                <i-tabler
                  name="alert-triangle"
                  class="tag-alert-icon"
                ></i-tabler>
                <span>{{ tag }}</span>
              </span>
              <!-- Standard dietary tags: functional semantic colors without glow -->
              <span
                class="tag-item"
                [ngClass]="getRestrictionBadgeClass(tag)"
                *ngIf="!isCriticalRestrictionTag(tag)"
              >
                <span>{{ tag }}</span>
              </span>
            </ng-container>
          </div>
        </div>
      </div>

      <ng-template #noRestrictions>
        <div class="no-restrictions-box">
          <i-tabler name="check"></i-tabler>
          <span
            >Sin restricciones alimentarias registradas para este grupo.</span
          >
        </div>
      </ng-template>
    </div>
  </mat-dialog-content>

  <!-- Modal Footer: Flat, clean CTA button -->
  <div class="modal-footer">
    <button
      type="button"
      mat-flat-button
      class="btn-close-modal"
      (click)="handleCloseModal()"
    >
      Cerrar
    </button>
  </div>
</div>
